const audioSinkService = {
    async setSinkId(audio, speakerDeviceId) {
        /**
         * LivestreamReducer uses null to mean "use default speaker".
         *
         * However, according to Audio Output API specification, default value is
         * an empty string. The default speaker is the most reliable choice, as
         * explained in RP-1754.
         *
         * So automatically translate any unused value to default.
         */
        const targetSinkId = speakerDeviceId || '';

        if (!audio || !audio.setSinkId || audio.sinkId === targetSinkId) {
            return Promise.resolve();
        }

        return audio.setSinkId(targetSinkId);
    },
};

export default audioSinkService;
